import "./page-title-breadcrumb.scss";

import Breadcrumbs from "@frontend/js/Components/Shared/Breadcrumbs/Breadcrumbs";

export default function PageTitleBreadcrumb({
    title,
    currentTitle = null,
    parentTitle = null,
    parentHref = null,
    grandparentTitle = null,
    grandparentHref = null,
    titleTag = "h1",
    titleClassName = "",
    variant = "default",
    skipParent = false,
}) {
    const TitleTag = titleTag;
    const breadcrumbCurrentTitle = currentTitle || title;
    const rootClassName = [
        "pageTitleBreadcrumb",
        variant ? `pageTitleBreadcrumb--${variant}` : "",
    ]
        .filter(Boolean)
        .join(" ");
    const headingClassName = ["pageTitleBreadcrumb__title", titleClassName]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={rootClassName}>
            <TitleTag className={headingClassName}>{title}</TitleTag>
            <Breadcrumbs
                currentTitle={breadcrumbCurrentTitle}
                parentTitle={skipParent ? null : parentTitle}
                parentHref={skipParent ? null : parentHref}
                grandparentTitle={grandparentTitle}
                grandparentHref={grandparentHref}
            />
        </div>
    );
}
